/* eslint-disable */
import { getStudentInfo, getScheduleRequest, getFutureSchedule } from '../api.js'
import {
  getStudentSchedule,
  getStudentScheduleDiff,
  postFutureSchedulePull,
  getFutureSchedulePull,
} from '../api.js'

import { find, isEmpty } from 'lodash'

import notifications from '../notifications.js'

var _vars = {
  studentInfos: undefined,
  scheduleRequests: undefined,
  futureSchedules: undefined,

  schedules: {
    current: {},
    request: {},
    future: {},
  },
}

async function _getAllStudentSchedulesFromServer(dbId) {
  try {
    let [studentInfosResponse, scheduleRequestsResponse, futureSchedulesResponse] = await Promise.all([
      getStudentInfo(dbId),
      getScheduleRequest(dbId),
      getFutureSchedule(dbId),
    ])

    console.log(studentInfosResponse.data)
    console.log(scheduleRequestsResponse.data)
    console.log(futureSchedulesResponse.data)
    _vars.studentInfos = studentInfosResponse.data
    _vars.scheduleRequests = scheduleRequestsResponse.data
    _vars.futureSchedules = futureSchedulesResponse.data
    return {
      studentInfos: _vars.studentInfos,
      scheduleRequests: _vars.scheduleRequests,
      futureSchedules: _vars.futureSchedules,
    }
  }
  catch (err) {
    notifications.pushError('Error getting student schedule information.')
  }
}

// eslint-disable-next-line
function _findDiffBetweenSchedules(schedule, compareSchedule) {
  return {
    info: {
      safetyVest: 'add',
      enclosedVehicle: 'remove',
    },
    somethingelse: {
      test: 'toast',
    }
  }
}

var exampleSchedule = {
  "student_db_id": 12717,
  "student": {
    "db_id": 12717,
    "internal_id": "CLDEMO-1000C",
    "public_id": "83945",
    "first_name": "Miranda",
    "middle_name": null,
    "last_name": "Charles",
    "date_of_birth": "2010-01-01",
    "gender": "female",
    "language": "en",
    "metastudent": {
      "school_year": "sum-25"
    }
  },
  "info": {
    "vest_info": null,
    "accommodations": {
      "info_aide": null,
      "info_wheelchair": false,
      "info_solo": false,
      "info_enclosed_vehicle": false,
      "info_booster_seat": false,
      "info_safety_vest": false,
      "info_safety_belt_locking_cover": false,
      "info_car_seat": false,
      "info_resident_district": null,
      "info_requesting_district": null
    },
    "student_release": "I",
    "medical_notes": "",
    "notes": "{\"additional\": \"{ \\\"additional\\\": \\\"\\\"}\"}",
    "grade": 100,
    "program": {
      "id": 2,
      "program_number": 0,
      "fin_code": 720,
      "description": "Public"
    }
  },
  "schedule": {
    "recurrence": "MTWRF",
    "weekdays": [
      {
        "week": "0",
        "weekday": "mon",
        "trips": [
          {
            "type": "outbound",
            "vehicle_code": "BLU09V",
            "departure_time": null,
            "dropoff_time": "06:50:00",
            "dropoff_address": {
              "street": "615 1ST AVE NE",
              "apartment": null,
              "city": "MINNEAPOLIS",
              "state": "MN",
              "zip_code": "55413",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_bus_stop": {
              "description": "CST",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_route": {
              "db_id": 1801,
              "number": "BLU09V__CST04A",
              "building": null,
              "description": "CST04A description",
              "window_sign": null
            },
            "trip_pickup_building": null
          }
        ]
      },
      {
        "week": "0",
        "weekday": "tue",
        "trips": [
          {
            "type": "outbound",
            "vehicle_code": "BLU09V",
            "departure_time": null,
            "dropoff_time": "06:50:00",
            "dropoff_address": {
              "street": "615 1ST AVE NE",
              "apartment": null,
              "city": "MINNEAPOLIS",
              "state": "MN",
              "zip_code": "55413",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_bus_stop": {
              "description": "CST",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_route": {
              "db_id": 1801,
              "number": "BLU09V__CST04A",
              "building": null,
              "description": "CST04A description",
              "window_sign": null
            },
            "trip_pickup_building": null
          }
        ]
      },
      {
        "week": "0",
        "weekday": "wed",
        "trips": [
          {
            "type": "outbound",
            "vehicle_code": "BLU09V",
            "departure_time": null,
            "dropoff_time": "06:50:00",
            "dropoff_address": {
              "street": "615 1ST AVE NE",
              "apartment": null,
              "city": "MINNEAPOLIS",
              "state": "MN",
              "zip_code": "55413",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_bus_stop": {
              "description": "CST",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_route": {
              "db_id": 1801,
              "number": "BLU09V__CST04A",
              "building": null,
              "description": "CST04A description",
              "window_sign": null
            },
            "trip_pickup_building": null
          }
        ]
      },
      {
        "week": "0",
        "weekday": "thu",
        "trips": [
          {
            "type": "outbound",
            "vehicle_code": "BLU09V",
            "departure_time": null,
            "dropoff_time": "06:50:00",
            "dropoff_address": {
              "street": "615 1ST AVE NE",
              "apartment": null,
              "city": "MINNEAPOLIS",
              "state": "MN",
              "zip_code": "55413",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_bus_stop": {
              "description": "CST",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_route": {
              "db_id": 1801,
              "number": "BLU09V__CST04A",
              "building": null,
              "description": "CST04A description",
              "window_sign": null
            },
            "trip_pickup_building": null
          }
        ]
      },
      {
        "week": "0",
        "weekday": "fri",
        "trips": [
          {
            "type": "outbound",
            "vehicle_code": "BLU09V",
            "departure_time": null,
            "dropoff_time": "06:50:00",
            "dropoff_address": {
              "street": "615 1ST AVE NE",
              "apartment": null,
              "city": "MINNEAPOLIS",
              "state": "MN",
              "zip_code": "55413",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_bus_stop": {
              "description": "CST",
              "latitude": 44.991058,
              "longitude": -93.252601
            },
            "dropoff_route": {
              "db_id": 1801,
              "number": "BLU09V__CST04A",
              "building": null,
              "description": "CST04A description",
              "window_sign": null
            },
            "trip_pickup_building": null
          }
        ]
      }
    ]
  },
  "misc": {
    "effective_date": "2026-07-23"
  },
  "district": {
    "id": 192,
    "code": "EZ-CLDEMO",
    "display_code": "CLDEMO",
    "state": "EZ",
    "name": "EZ Client Demo",
    "partition_id": 2,
    "billing_method": null,
    "ui_data": {}
  }
}

async function _getFutureSchedule(studentId, futureScheduleId, scheduleRequestId) {
  if (futureScheduleId) {
    return _getScheduleFromServer(studentId, 'future', {
      futureScheduleId: futureScheduleId,
      scheduleRequestId: scheduleRequestId,
    })
  }
  else if (scheduleRequestId) {
    return _getScheduleFromServer(studentId, 'future', {
      scheduleRequestId: scheduleRequestId,
    })
  }
  else {
    return _getScheduleFromServer(studentId, 'future')
  }
}

async function _getScheduleFromServer(studentId, scheduleType, idsObject) {
  try {
    let queryParams = {}
    if (idsObject) {
      if (idsObject.studentInfoId) {
        queryParams.studentInfoId = idsObject.studentInfoId
      }
      else if (idsObject.futureScheduleId) {
        queryParams.futureScheduleId = idsObject.futureScheduleId
      }
      else if (idsObject.scheduleRequestId) {
        queryParams.scheduleRequestId = idsObject.scheduleRequestId
      }
    }
    let response = await getStudentSchedule(studentId, scheduleType, queryParams)
    let scheduleData
    if (isEmpty(response.data)) {
      scheduleData = await _initiateFutureSchedulePull(studentId, idsObject.scheduleRequestId)
    }
    else {
      scheduleData = response.data
    }
    return scheduleData
  }
  catch (error) {
    notifications.pushError(`Student Schedule failed to load! ${error.response.data.error}`, error)
  }
}

async function _getScheduleDiffFromServer(studentId, scheduleType, scheduleDbId, compareScheduleType, compareScheduleDbId) {
  try {
    let response = await getStudentScheduleDiff(
      studentId,
      {
        type: scheduleType,
        typeId: scheduleDbId,
        againstType: compareScheduleType,
        againstTypeId: compareScheduleDbId,
      },
    )
    return response.data
  }
  catch (error) {
    notifications.pushError(`Student Schedule failed to load! ${error.response.data.error}`, error)
  }
}

async function _initiateFutureSchedulePull(studentId, scheduleRequestId, createNew) {
  try {
    let body = {}
    if (scheduleRequestId) {
      body['sr_id'] = scheduleRequestId
    }
    if (createNew) {
      body['create_new'] = createNew
    }
    let postResponse = await postFutureSchedulePull(studentId, body)
    let pollingPromise = new Promise((resolve, reject) => {
      let retryGetPollFunc = async () => {
        try {
          let getResponse = await getFutureSchedulePull(studentId, { scheduleRequestId: scheduleRequestId })
          if (getResponse.status === 206) {
            return
          }
          clearInterval(intervalId)
          resolve(getResponse.data)
          return getResponse.data
        }
        catch (error) {
          clearInterval(intervalId)
          reject(error)
        }
      }

      let intervalId = setInterval(retryGetPollFunc, 4000)
    })

    return pollingPromise
  }
  catch (error) {
    notifications.pushError(`Student Future Schedule failed begin pulling from 3rd Party Routing Software! ${error.response.data.error}`, error)
  }
}

function _init() {
  // do nothing
}

_init()

export default {
  getFutureSchedule: _getFutureSchedule,
  getScheduleFromServer: _getScheduleFromServer,
  getScheduleDiffFromServer: _getScheduleDiffFromServer,
  getAllStudentSchedulesFromServer: _getAllStudentSchedulesFromServer,
  initiateFutureSchedulePull: _initiateFutureSchedulePull,
}
